window.onload = function() {
  if (window.innerWidth > 768) {
  var elements = document.body.getElementsByTagName('p');
  for (var i = 0; i < elements.length; i++) {
    var words = elements[i].innerHTML.split(' ');
    for (var j = 0; j < words.length; j++) {
      if (words[j] === 'patented') {
        words[j] = '<a class="custom_tooltip">patented<span class="tooltiptext">ZL202230416505.1<br> CN 212814299 U</span></a>';
      } else if (words[j] === 'PATENT') {
        words[j] = '<a class="custom_tooltip">PATENT<span class="tooltiptext">ZL202230416505.1<br> CN 212814299 U</span></a>';
      }
    }
    elements[i].innerHTML = words.join(' ');
  }
}
};
